@if (form) {
  <form class="row g-3" [formGroup]="form">
    @for (group of json_form_data; track group; let groupIndex = $index) {
      <div [formArrayName]="'groups'" class="col col-12">
        <div
          class="card"
          [tds-data-loader]="{ key: 'order-fields-' + group.name, size: 'lg', as_overlay: true }"
        >
          <div [formGroupName]="groupIndex" class="card-body">
            <h4 class="card-title pb-2">{{ group.display_name }}</h4>
            <div class="row d-flex g-3">
              @for (field of sortFields(group.fields); track field) {
                <ng-container [formGroupName]="'fields'">
                  <!-- Divider -->
                  @if (divider[group.name]?.includes(field.name)) {
                    <span class="col-12">
                      <hr class="m-0" />
                    </span>
                  }
                  @switch (field.type) {
                    <!-- Text -->
                    @case (['text', 'string'].includes(field.type) && field.type) {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            class="form-label"
                            for="{{ field.name }}-{{ field.id }}"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <input
                          type="text"
                          id="{{ field.name }}-{{ field.id }}"
                          class="form-control"
                          restrict-input="{{ getTextDirective(field.name, group) }}"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          [formControl]="field.control"
                          [required]="field.required"
                        />
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Hidden -->
                    @case ('hidden') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            class="form-label"
                            for="{{ field.name }}-{{ field.id }}"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <input
                          type="text"
                          id="{{ field.name }}-{{ field.id }}"
                          class="form-control"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          [formControl]="field.control"
                          [required]="field.required"
                        />
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Password -->
                    @case ('password') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <input
                          type="password"
                          id="{{ field.name }}-{{ field.id }}"
                          class="form-control fw-bold"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          [formControl]="field.control"
                          [required]="field.required"
                          restrict-input="no_empty_space"
                        />
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Expiry date -->
                    @case ('expiry_date') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <input
                          id="{{ field.name }}-{{ field.id }}"
                          class="form-control"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          type="text"
                          placeholder="MM/YY"
                          maxlength="5"
                          restrict-input="expiry_date"
                          [formControl]="field.control"
                          [required]="field.required"
                        />
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Textarea -->
                    @case ('textarea') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <textarea
                          class="form-control"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          id="{{ field.name }}-{{ field.id }}"
                          [formControl]="field.control"
                          [required]="field.required"
                          restrict-input="no_empty_space"
                        ></textarea>
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Select -->
                    @case ('select') {
                      @if (
                        !['new_carrier_account'].includes(field.name) ||
                        hasNewCarrierAccounts(group)
                      ) {
                        <div
                          class="form-group {{ splitColumns(group, field) }}"
                          attr.aria-describedby="{{ field.id }}-help"
                        >
                          <ng-container
                            *ngTemplateOutlet="headerTemplate; context: { field: field }"
                          />
                          @if (field.label) {
                            <label
                              for="{{ field.name }}-{{ field.id }}"
                              class="form-label"
                              [ngClass]="{ required: field.required }"
                            >
                              {{ field.label }}
                            </label>
                          }
                          <select
                            id="{{ field.name }}-{{ field.id }}"
                            class="form-select"
                            [class.is-invalid]="field.control.errors && field.control.dirty"
                            [formControl]="field.control"
                          >
                            @if (!hideSelectOneOption(field.name, group)) {
                              <option value="">
                                {{ 'select_one' | translate }}
                              </option>
                            }
                            @for (option of field.options; track option) {
                              <option value="{{ option.value }}">
                                {{ option.label }}
                              </option>
                            }
                          </select>
                          <ng-container
                            *ngTemplateOutlet="errorTemplate; context: { field: field }"
                          />
                          <ng-container
                            *ngTemplateOutlet="helpTemplate; context: { field: field }"
                          />
                        </div>
                      }
                    }
                    <!-- Grouped Select -->
                    @case ('grouped_select') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        <select
                          id="{{ field.name }}-{{ field.id }}"
                          class="form-select"
                          [class.is-invalid]="field.control.errors && field.control.dirty"
                          [formControl]="field.control"
                        >
                          @if (!hideSelectOneOption(field.name, group)) {
                            <option value="">
                              {{ 'select_one' | translate }}
                            </option>
                          }
                          @for (group of field.grouped_options; track group) {
                            <optgroup [label]="group.label">
                              @for (item of group.options; track item) {
                                <option [value]="item.value">
                                  {{ item.label }}
                                </option>
                              }
                            </optgroup>
                          }
                        </select>
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Radio -->
                    @case ('radio') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        <fieldset>
                          <label class="form-label" [ngClass]="{ required: field.required }">
                            {{ field.label }}
                          </label>
                          @for (option of field.options; track option; let i = $index) {
                            <div class="form-check">
                              <input
                                id="{{ group.name }}-{{ field.id }}-{{ i }}"
                                class="form-check-input"
                                [class.is-invalid]="field.control.errors && field.control.dirty"
                                type="radio"
                                [value]="option.value"
                                [name]="field.name"
                                [formControl]="field.control"
                              />
                              <label
                                class="form-check-label"
                                for="{{ group.name }}-{{ field.id }}-{{ i }}"
                              >
                                {{ option.label }}
                              </label>
                            </div>
                          }
                        </fieldset>
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Date -->
                    @case ('date') {
                      <ts-date-picker
                        class="{{ splitColumns(group, field) }}"
                        id="{{ field.name }}-{{ field.id }}"
                        [label]="field.label"
                        [name]="field.name"
                        [help_text]="field.help_text"
                        [required]="field.required"
                        [control]="field.control"
                        [header_text]="field.header_text"
                        [validate_pattern]="field.value !== field.control.value"
                      />
                    }
                    <!-- File input -->
                    @case ('file') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        @if (field.label) {
                          <label
                            for="file-input-{{ field.id }}"
                            class="form-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        }
                        @if (!field.value) {
                          <input
                            id="file-input-{{ field.id }}"
                            class="form-control"
                            [class.is-invalid]="field.control.errors && field.control.dirty"
                            type="file"
                            [required]="field.required"
                            (change)="onFileChange($event, field, field.control)"
                          />
                        }
                        @if (field.value) {
                          <div id="file-value-{{ field.id }}">
                            <span class="d-flex align-items-center">
                              {{ field.value }} &nbsp;
                              <span
                                class="material-icons fs-6 cursor-pointer"
                                aria-hidden="true"
                                (click)="deleteFile(field)"
                              >
                                close
                              </span>
                            </span>
                          </div>
                        }
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Checkbox -->
                    @case ('checkbox') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        <div class="form-check">
                          <input
                            id="{{ field.name }}-{{ field.id }}"
                            class="form-check-input"
                            [class.is-invalid]="field.control.errors && field.control.dirty"
                            type="checkbox"
                            [name]="field.name"
                            [formControl]="field.control"
                            [required]="field.required"
                          />
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-check-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        </div>
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Boolean -->
                    @case ('boolean') {
                      <div
                        class="form-group {{ splitColumns(group, field) }}"
                        attr.aria-describedby="{{ field.id }}-help"
                      >
                        <ng-container
                          *ngTemplateOutlet="headerTemplate; context: { field: field }"
                        />
                        <div class="form-check form-switch">
                          <input
                            id="{{ field.name }}-{{ field.id }}"
                            class="form-check-input"
                            [class.is-invalid]="field.control.errors && field.control.dirty"
                            type="checkbox"
                            role="switch"
                            [name]="field.name"
                            [formControl]="field.control"
                          />
                          <label
                            for="{{ field.name }}-{{ field.id }}"
                            class="form-check-label"
                            [ngClass]="{ required: field.required }"
                          >
                            {{ field.label }}
                          </label>
                        </div>
                        <ng-container
                          *ngTemplateOutlet="errorTemplate; context: { field: field }"
                        />
                        <ng-container *ngTemplateOutlet="helpTemplate; context: { field: field }" />
                      </div>
                    }
                    <!-- Readonly -->
                    @case ('readonly') {
                      @switch (field.name) {
                        @case ('country_id') {
                          <ng-container
                            *ngTemplateOutlet="
                              addressTemplate;
                              context: { group: group, field: field }
                            "
                          />
                        }
                        @case ('agreement') {
                          <ng-container
                            *ngTemplateOutlet="
                              agreementTemplate;
                              context: { group: group, field: field }
                            "
                          />
                        }
                        @case ('credit_card.card_number') {
                          <ng-container
                            *ngTemplateOutlet="
                              paymentDetailTemplate;
                              context: { group: group, field: field }
                            "
                          />
                        }
                        @case ('credit_card.billing_address') {
                          <ng-container
                            *ngTemplateOutlet="
                              creditCardAddressTemplate;
                              context: { group: group, field: field }
                            "
                          />
                        }
                        @case ('same_as_shipping_address_field') {
                          <div>
                            <ng-container
                              *ngTemplateOutlet="billingAddressTemplate; context: { field: field }"
                            />
                          </div>
                        }
                        @case ('current_carrier_account') {
                          <div>
                            <ng-container>
                              @if (hasNewCarrierAccounts(group)) {
                                <span>
                                  <ng-container
                                    *ngTemplateOutlet="
                                      currentCarrierAccountTemplate;
                                      context: { group: group, field: field }
                                    "
                                  />
                                </span>
                              } @else {
                                <div class="col-12 form-group">
                                  <span class="d-flex col alert alert-warning mb-0" role="alert">
                                    {{ 'no_additional_carrier_accounts' | translate }}
                                  </span>
                                </div>
                              }
                            </ng-container>
                          </div>
                        }
                        @default {
                          @if (readOnlyTemplate(field, group)) {
                            <div
                              [innerHTML]="readOnlyTemplate(field, group) | domSanitizer"
                              [ngClass]="[splitColumns(group, field), 'normalize-external-styles']"
                            ></div>
                          }
                        }
                      }
                    }
                    <!-- Device select -->
                    @case ('device_select') {
                      <ts-device-select
                        class="{{ splitColumns(group, field) }}"
                        id="{{ field.id }}"
                        [label]="field.label"
                        [name]="field.name"
                        [help_text]="field.help_text ?? ''"
                        [required]="field.required"
                        [control]="field.control"
                        [header_text]="field.header_text"
                      />
                    }
                    <!-- Line select -->
                    @case ('line_select') {
                      <ts-line-select
                        class="{{ splitColumns(group, field) }}"
                        id="{{ field.id }}"
                        [label]="field.label"
                        [name]="field.name"
                        [help_text]="field.help_text ?? ''"
                        [required]="field.required"
                        [control]="field.control"
                        [header_text]="field.header_text"
                      />
                    }
                    <!-- Person select -->
                    @case ('person_select') {
                      <ts-person-select
                        class="{{ splitColumns(group, field) }}"
                        id="{{ field.id }}"
                        [label]="field.label"
                        [name]="field.name"
                        [help_text]="field.help_text ?? ''"
                        [required]="field.required"
                        [control]="field.control"
                        [header_text]="field.header_text"
                      />
                    }
                  }
                </ng-container>
              }
            </div>
          </div>
        </div>
      </div>
    }
  </form>
}

<ng-template #addressTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    @if (getAddressLabel(group)) {
      <div
        class="form-label pt-2 normalize-external-styles"
        [innerHTML]="getAddressLabel(group) | domSanitizer"
      ></div>
    }

    <div>
      <span>
        {{ getFieldValue('company_name', group) }}
      </span>
    </div>
    <div>
      <span>{{ getFieldValue('address1', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('address2', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('city', group) }}, {{ getFieldValue('state', group) }}</span>
      <span>{{ getFieldValue('zip', group) }}</span>
    </div>
    <div>{{ field.display_name }}</div>
  </div>
</ng-template>

<ng-template #creditCardAddressTemplate let-group="group" let-field="field">
  <span class="col-12">
    <hr class="m-0" />
  </span>

  <div [class]="splitColumns(group, field)">
    <h5 class="form-label py-2">{{ 'billing_address' | translate }}</h5>
    <ng-container *ngTemplateOutlet="billingAddressTemplate; context: { field: field }" />
  </div>
</ng-template>

<ng-template #billingAddressTemplate let-field="field">
  <div>
    <span>{{ field.value.company_name }}</span>
  </div>
  <div>
    <span>{{ field.value.address1 }}</span>
  </div>
  <div>
    <span>{{ field.value.address2 }}</span>
  </div>
  <div>
    <span>{{ field.value.city }}, {{ field.value.state }}</span>
    <span>{{ field.value.zip }}</span>
  </div>
  <div>
    <span>{{ field.value.country }}</span>
  </div>
</ng-template>

<ng-template #currentCarrierAccountTemplate let-group="group" let-field="field">
  <div>
    <label
      class="form-label"
      for="{{ field.name }}-{{ field.id }}"
      [ngClass]="{ required: field.required }"
    >
      {{ field.label }}
    </label>

    <select
      id="{{ field.name }}-{{ field.id }}"
      class="form-select"
      [class.is-invalid]="field.control.errors && field.control.dirty"
      [formControl]="field.control"
    >
      @if (getFieldValue('current_carrier_account', group) !== '') {
        <option [value]="getFieldValue('current_carrier_account', group)">
          {{ getFieldValue('current_carrier_account', group) }}
        </option>
      } @else {
        <option>
          {{ 'n_a' | translate }}
        </option>
      }
    </select>
  </div>
</ng-template>

<ng-template #agreementTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    <div
      id="{{ field.name }}-{{ field.id }}"
      class="resizable-element normalize-external-styles"
      [ngClass]="{ scrollable: field.value!.toString().length > 1500 }"
      [innerHTML]="field.value!.toString() | domSanitizer"
    ></div>

    <div
      class="d-inline-flex align-items-center cursor-pointer pt-2"
      (click)="printAgreement(group, field.value)"
    >
      <span class="material-icons pe-1 print-icon" aria-hidden="true">print</span>
      <a href="javascript:void(0)">
        {{ 'print_this_document' | translate }}
      </a>
    </div>
  </div>
</ng-template>

<ng-template #paymentDetailTemplate let-group="group" let-field="field">
  <div [class]="splitColumns(group, field)">
    <div class="d-flex align-items-center">
      @if (getFieldValue('credit_card.card_type', group)) {
        <img
          class="img-fluid pe-2 payment-card-img"
          src="{{ getPaymentCardImage(getFieldValue('credit_card.card_type', group)) }}"
          alt="payment card"
        />
      }
      <span>{{ getFieldValue('credit_card.card_number', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('credit_card.name_on_card', group) }}</span>
    </div>
    <div>
      <span>{{ getFieldValue('credit_card.expires', group) }}</span>
    </div>
  </div>
</ng-template>

<ng-template #headerTemplate let-field="field">
  @if (field.header_text) {
    <div
      class="header-text normalize-external-styles"
      [innerHTML]="field.header_text | domSanitizer"
    ></div>
  }
</ng-template>

<ng-template #errorTemplate let-field="field">
  @if (field.control.dirty && field.control.errors) {
    <div id="{{ field.id }}-error" class="text-danger mt-2">
      @if (field.control.errors['required']) {
        <span>{{ 'input_is_required' | translate: field.label }}</span>
      }
      @if (field.control.errors['expired_date']) {
        <span>{{ 'invalid_expiry_date' | translate }}</span>
      }
      @if (field.control.errors['_error']) {
        <span>
          <ul class="m-0 p-0 list-unstyled">
            @for (error of field.control.errors['_error']; track error) {
              <li class="fw-light">{{ error }}</li>
            }
          </ul>
        </span>
      }
    </div>
  }
</ng-template>

<ng-template #helpTemplate let-field="field">
  @if (field.help_text) {
    <div id="{{ field.id }}-help" class="form-text">
      {{ field.help_text }}
    </div>
  }
</ng-template>
